import magic from '../magic';
const node=3;
function byte(v){if(!Number.isInteger(v)||v<0||v>255)throw new Error('Invalid lighting value');return v;}
export async function setLightTimer(ms,bar=false){
  if(!Number.isInteger(ms)||ms<0||ms>0x7fffffff)throw new Error('Invalid lighting timer');
  const b=new Uint8Array(4);new DataView(b.buffer).setUint32(0,ms,true);
  await magic.writeSDO(node,bar?0x2005:0x2000,0,b);
  magic.lights[bar?'ledBar':'timer']=Math.round(ms/1000);
  magic.bleEventDispatcher.emit('lights',magic.lights);
}
export async function readLayer(index){
  if(!Number.isInteger(index)||index<0||index>4)throw new Error('Invalid layer');
  const b=await magic.readSDO(node,0x2100+index,0);
  if(b.length!==9)throw new Error('Invalid layer snapshot');
  const layers=[...(magic.lights.layers||[])];
  layers[index]={enabled:b[0],startLED:b[1],endLED:b[2],color:Array.from(b.slice(3,6)),effect:b[6],effectStrength:b[7],effectSpeed:b[8]};
  magic.lights.layers=layers;
  magic.bleEventDispatcher.emit('lights',magic.lights);
}
function updateLayer(index, patch) {
  const layers=[...(magic.lights.layers||[])];
  layers[index]={...layers[index],...patch};
  magic.lights.layers=layers;
  magic.bleEventDispatcher.emit('lights',magic.lights);
}
export async function setLayerConfig(index,enabled,start,end,r,g,b){
  await magic.writeSDO(node,0x2003,0,Uint8Array.from([index,enabled,start,end,r,g,b].map(byte)));
  updateLayer(index,{enabled,startLED:start,endLED:end,color:[r,g,b]});
}
export async function setLayerEffect(index,effect,strength,speed){
  await magic.writeSDO(node,0x2004,0,Uint8Array.from([index,effect,strength,speed].map(byte)));
  updateLayer(index,{effect,effectStrength:strength,...(speed?{effectSpeed:speed}:{})});
}
export async function readLightingConfig(isCurrent=()=>true){
  for(let i=0;i<5;i++){if(!isCurrent())return;await readLayer(i);}
  const white=[];
  for(let sub=1;sub<=3;sub++){if(!isCurrent())return;const b=await magic.readSDO(node,0x2001,sub);white.push(b[0]);}
  if(!isCurrent())return;
  magic.lights.white=white;magic.bleEventDispatcher.emit('lights',magic.lights);
}

// Validate the whole mood first; acknowledged writes update the local cache.
export async function applyMoodLayers(layers) {
  if(!Array.isArray(layers)||layers.length>5)throw new Error('Invalid mood layers');
  const writes=[];
  for(let i=0;i<layers.length;i++) {
    const l=layers[i];if(!l)continue;
    const config=[i,l.enabled?1:0,l.startLED??0,l.endLED??0,...[0,1,2].map(c=>l.color?.[c]??0)].map(byte);
    writes.push([0x2003,config]);
    if(l.effect!==undefined||l.effectStrength!==undefined||l.effectSpeed!==undefined)
      writes.push([0x2004,[i,l.effect??0,l.effectStrength??0,l.effectSpeed??1].map(byte)]);
  }
  for(const [index,value] of writes) {
    if(index===0x2003)await setLayerConfig(...value);
    else await setLayerEffect(...value);
  }
}
